import styled from 'styled-components';
import { ForwardedRef, forwardRef } from 'react';

import useDevice from '@hooks/useDevice';
import { Statistics, Summary } from 'components/molecules';
import { ConnectActionButtons } from '@components/atoms';
import { localUlr } from '@shared/constants/video';

function CommonInfo({}, ref: ForwardedRef<HTMLDivElement | null>) {
  const { isMobile, isTablet } = useDevice();

  return (
    <StyledSection $isMobile={isMobile} $isTablet={isTablet}>
      <Summary videoId={localUlr} ref={ref} />

      <Statistics />

      {(isMobile || isTablet) && (
        <ConnectActionButtons
          width="270px"
          btnWidth="120px"
          margin="5px auto"
          ref={ref}
        />
      )}
    </StyledSection>
  );
}

const StyledSection = styled.section<{
  $isMobile: boolean;
  $isTablet: boolean;
}>`
  width: 100%;
  position: relative;

  display: flex;
  flex-direction: column;

  padding-top: ${({ $isMobile }) => ($isMobile ? '116px' : '130px')};
  margin-bottom: 100px;
`;

export default forwardRef<HTMLDivElement | null, {}>(CommonInfo);
